import { browserSupportsWebAuthn, startAuthentication } from "@simplewebauthn/browser";
import { useState } from "preact/hooks";
import { api } from "../api";

export function Login({ passkeys, onDone }: { passkeys: number; onDone: () => void }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const canPasskey = passkeys > 0 && browserSupportsWebAuthn();

  async function withPassword(e: Event) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.loginPassword(password);
      onDone();
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  async function withPasskey() {
    setBusy(true);
    setError(null);
    try {
      const optionsJSON = await api.loginPasskeyOptions();
      const response = await startAuthentication({ optionsJSON });
      await api.loginPasskeyVerify(response);
      onDone();
    } catch (err) {
      const name = (err as Error).name;
      setError(name === "NotAllowedError" ? "Connexion annulée." : (err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div class="login">
      <form onSubmit={withPassword}>
        <h1>Messagerie</h1>
        <p>robinluiz.fr</p>
        {canPasskey && (
          <>
            <button type="button" class="btn primary" onClick={withPasskey} disabled={busy}>
              Se connecter avec une passkey
            </button>
            <div class="divider">ou</div>
          </>
        )}
        <input
          type="password" autocomplete="current-password" placeholder="Mot de passe" aria-label="Mot de passe"
          value={password} onInput={(e) => setPassword((e.target as HTMLInputElement).value)} required
        />
        <button type="submit" class={canPasskey ? "btn" : "btn primary"} disabled={busy || !password}>
          Se connecter
        </button>
        {error && <div class="error" role="alert">{error}</div>}
      </form>
    </div>
  );
}
